/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step4_Permission_AdminInputs */



/**
* | output |
* | --- |
* | "Admin" |
*
* @param {Spaces_Wizard_Step4_Permission_AdminInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step4_permission_admin = /** @type {((inputs?: Spaces_Wizard_Step4_Permission_AdminInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step4_Permission_AdminInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Admin")
	return /** @type {LocalizedString} */ ("Admin")
});